const services = [
  {
    icon: 'ri-scissors-2-line',
    name: 'Skin Fade',
    description: 'Precision clipper work creating seamless transitions from skin to hair, delivering sharp, clean fades that last.',
  },
  {
    icon: 'ri-contrast-drop-2-line',
    name: 'Taper Fade',
    description: 'Expert blending technique for a gradual fade that suits any style, from classic to contemporary looks.',
  },
  {
    icon: 'ri-grid-line',
    name: 'Buzz Cut',
    description: 'Clean, uniform length all over with precise edging and lineup for a sharp, low-maintenance style.',
  },
  {
    icon: 'ri-scissors-cut-line',
    name: 'Classic Haircut',
    description: 'Timeless scissor cuts tailored to your face shape and personal style, executed with professional precision.',
  },
  {
    icon: 'ri-user-smile-line',
    name: 'Beard Trim',
    description: 'Expert beard shaping and trimming to maintain your desired length and style with clean, defined lines.',
  },
  {
    icon: 'ri-focus-3-line',
    name: 'Beard Line Up',
    description: 'Sharp, precise beard edging and cheek line definition for a polished, well-groomed appearance.',
  },
  {
    icon: 'ri-star-line',
    name: 'Haircut & Beard Combo',
    description: 'Complete grooming package combining premium haircut with expert beard styling for a fully refined look.',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start mb-16">
          <div className="mb-8 md:mb-0">
            <div className="text-red-600 text-xs tracking-widest font-semibold mb-4 whitespace-nowrap">OUR SERVICES</div>
            <h2 className="text-6xl md:text-7xl font-bold text-black leading-tight">
              Precision Grooming<br />
              For The Modern Man
            </h2>
          </div>
          <div className="md:w-2/5">
            <p className="text-gray-600 text-lg leading-relaxed">
              Every service at Reborn Barbershop is delivered with meticulous attention to detail, using premium products and advanced techniques to ensure you leave looking and feeling your absolute best.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-red-600 transition-colors">
                <i className={`${service.icon} text-3xl text-red-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-2xl font-bold text-black mb-4">{service.name}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">{service.description}</p>
              <button className="text-red-600 text-sm font-semibold flex items-center gap-2 hover:gap-3 transition-all whitespace-nowrap">
                LEARN MORE
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}